module.exports = __webpack_public_path__ + "static/junior-10-d72d2972cc8e5b83a898cf80c570ed59.jpg";